import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Grid, styled } from '@mui/material'

import { getReferralSources } from '../../../store/duck/constants'
// @ts-ignore
import { useNavigateWithQueryString } from '../../../utils'
import KioskScreen from '../KioskScreen'
import ReferralSourceSelector from './ReferralSourceSelector'

const StyledButton = styled('button')(({ theme }) => ({
  width: 176,
  height: 56,
  borderRadius: 28,
  border: theme.constants.inactiveBorder,
  textTransform: 'none',
  fontSize: '1.6rem',
  fontWeight: 500,
  backgroundColor: theme.palette.common.white,
  color: theme.colors.tabLabel,
  marginRight: theme.spacing(4),
  '&:hover': {
    backgroundColor: theme.palette.grey[50],
  },
}))

interface Props {
  readonly onBack?: () => void
  readonly onFinish?: () => void
  readonly onSkip?: () => void
  readonly onSourceSelected?: (sourceId: string) => void
}

const HowDidYouHearScreen: React.FC<Props> = ({
  onSourceSelected,
  onBack,
  onSkip,
  onFinish,
}) => {
  const { t } = useTranslation('Common')
  const [selectedSourceId, setSelectedSourceId] = useState<string | null>(null)
  const ReferralSources = useSelector(getReferralSources)
  const navigateWithQueryString = useNavigateWithQueryString()

  const handleSourceClick = (sourceId: string) => {
    setSelectedSourceId(sourceId)
    if (onSourceSelected) {
      onSourceSelected(sourceId)
    }
  }

  const handleBack = () => {
    if (onBack) {
      onBack()
    }
  }
  const handleSkip = () => {
    if (onSkip) {
      onSkip()
      return
    }
    navigateWithQueryString({ url: '/' })
  }
  const handleFinish = () => {
    if (onFinish) {
      onFinish()
    } else {
      navigateWithQueryString({ url: '/' })
    }
  }

  return (
    <KioskScreen
      additionalLabel={
        <Grid item xs sm="auto">
          <StyledButton onClick={handleSkip}>{t('Common:SKIP')}</StyledButton>
        </Grid>
      }
      justifyContent="flex-start"
      proceedButtonLabel={t('Common:FINISH')}
      onBack={onBack ? handleBack : undefined}
      onProceed={handleFinish}
    >
      <ReferralSourceSelector
        referralSources={ReferralSources}
        selectedSourceId={selectedSourceId}
        onSourceSelected={handleSourceClick}
      />
    </KioskScreen>
  )
}

export default HowDidYouHearScreen
